/** @jsx jsx */
import { jsx } from "theme-ui";
import { StaticQuery, graphql } from "gatsby";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import sanityConfig from "../../../sanityConfig";
import { getGatsbyImageData } from "gatsby-source-sanity";
import Container from "../../container";
import appstore from "../../../images/Badge_US-UK_white.svg";
import ada from "../../../images/ADASC-white.svg";
import aicpa from "../../../images/SOC_NonCPA_white.svg";
import hipaa from "../../../images/HIPAA_Compliant_White.svg";
import secure from "../../../images/secure.png";
import LinkResolve from "../../serializers/linkResolve";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import FormFooter from "./formFooter";

function returnSocialImage(image, alt) {
  return <img src={image.asset.url} alt={alt} />;
}

const Footer = (props) => {
  const url =
    "//everplans.us7.list-manage.com/subscribe/post?u=8b94d865d06b4fafdae3f2423&amp;id=fdb52c78d8&amp;f_id=00ecc2e1f0";
  let setApfmTag = "";
  if (typeof document !== "undefined") {
    const getCookieValue = (name) =>
      document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() ||
      "";
    const apfmCookie = getCookieValue("apfm");
    if (
      (apfmCookie && apfmCookie == "true") ||
      props?.node?.slug?.current == "aplaceformom"
    ) {
      setApfmTag = "52583";
    }
  }
  return (
    <StaticQuery
      query={graphql`
        query FooterQuery {
          sanityFooter {
            _rawFooterLinks(resolveReferences: { maxDepth: 10 })
            _rawSocialMedia(resolveReferences: { maxDepth: 10 })
          }
        }
      `}
      render={(data) => (
        <footer
          sx={{
            backgroundColor: "primary",
            padding: "40px 0px",
            color: "#F1F1F1",
          }}
        >
          <div
            sx={{
              borderBottom: "1px solid #F1F1F1",
              paddingBottom: "40px",
            }}
          >
            <Container>
              <div
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                }}
              >
                <div
                  sx={{
                    display: "flex",
                    width: ["100%", "40%"],
                    flexWrap: "wrap",
                    "> nav": {
                      width: ["auto", "calc(100% / 3)"],
                      marginRight: ["50px", "0px"],
                      marginBottom: ["50px", "0px"],
                      "> div": {
                        fontWeight: "500",
                        marginBottom: "20px",
                      },
                      a: {
                        color: "#F1F1F1",
                        display: "block",
                        fontWeight: "400",
                        marginBottom: "10px",
                        "&last-child": {
                          marginBottom: "0px",
                        },
                      },
                    },
                  }}
                >
                  {data.sanityFooter._rawFooterLinks.map((menuGroup, index) => (
                    <nav key={index} aria-label={menuGroup.title}>
                      <div>{menuGroup.title}</div>
                      <ul
                        role="menubar"
                        aria-label={menuGroup.title}
                        sx={{
                          padding: "0px",
                          margin: "0px",
                        }}
                      >
                        {menuGroup.links.map((link, index) => (
                          <li
                            role="menuitem"
                            sx={{
                              listStyle: "none",
                              a: {
                                textDecoration: "none",
                                ":hover": {
                                  textDecoration: "underline",
                                },
                              },
                            }}
                            key={index}
                          >
                            <LinkResolve
                              link={link.link}
                              children={link.label}
                              target="_self"
                            />
                          </li>
                        ))}
                      </ul>
                    </nav>
                  ))}
                </div>
                <div
                  sx={{
                    width: ["100%", "50%", "35%"],
                    maxWidth: ["100%", "370px"],
                  }}
                >
                  <ul
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      padding: "0px",
                      marginTop: ["0px", "0px"],
                      li: {
                        width: "38px",
                        height: "38px",
                        marginRight: "32px",
                        listStyle: "none",
                        img: {
                          width: "100%",
                          height: "auto",
                        },
                        "&:last-child": {
                          marginRight: "0px",
                        },
                      },
                    }}
                  >
                    {data.sanityFooter._rawSocialMedia.map(
                      (socialGroup, index) => (
                        <li key={index}>
                          <a
                            href={socialGroup.link.url}
                            aria-label={socialGroup.link.arialLabel}
                            target="_blank"
                            sx={{
                              "&:hover": {
                                img: {
                                  filter:
                                    "brightness(0) saturate(100%) invert(35%) sepia(42%) saturate(6218%) hue-rotate(231deg) brightness(102%) contrast(96%)",
                                },
                              },
                            }}
                          >
                            {returnSocialImage(socialGroup.icon, socialGroup.link.arialLabel)}
                          </a>
                        </li>
                      )
                    )}
                  </ul>
                  <div
                    sx={{
                      marginTop: "25px",
                      marginBottom: "10px",
                      fontWeight: "500",
                    }}
                  >
                    JOIN OUR NEWSLETTER
                  </div>
                  <MailchimpSubscribe
                    url={url}
                    render={({ subscribe, status, message }) => (
                      <FormFooter
                        status={status}
                        message={message}
                        onValidated={(formData) =>
                          subscribe({ ...formData, tags: setApfmTag })
                        }
                      />
                    )}
                  />
                  <a
                    href="https://apps.apple.com/us/app/everplans/id1590237847"
                    target="_blank"
                    sx={{
                      "&:hover": {
                        img: {
                          filter:
                            "brightness(0) saturate(100%) invert(35%) sepia(42%) saturate(6218%) hue-rotate(231deg) brightness(102%) contrast(96%)",
                        },
                      },
                    }}
                  >
                    <img
                      sx={{
                        width: "142px",
                        marginTop: "30px",
                      }}
                      src={appstore}
                      alt="App Store"
                    />
                  </a>
                </div>
              </div>
            </Container>
          </div>
          <div
            sx={{
              padding: "30px 0px 0px 0px",
            }}
          >
            <Container>
              <div
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <div
                  sx={{
                    width: ["100%", "300px"],
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    a: {
                      display: "inline-block",
                      marginBottom: "25px",
                    },
                    "> div": {
                      display: "inline-block",
                      marginBottom: "25px",
                    },
                  }}
                >
                  <div
                    sx={{
                      width: "141px",
                      marginRight: "25px",
                    }}
                  >
                    <img src={hipaa} alt="HIPAA Compliant" />
                  </div>
                  <div
                    href="#"
                    sx={{
                      width: "52px",
                      marginRight: "25px",
                    }}
                  >
                    <img src={aicpa} alt="AICPA SOC" />
                  </div>
                  <a
                    href="https://adasitecompliancetools.com/ap.asp?h=EVRPLN"
                    target="_blank"
                    sx={{
                      width: "52px",
                    }}
                  >
                    <img src={ada} alt="ADA Site Compliance" />
                  </a>
                </div>
                <div
                  sx={{
                    width: ["100%", "100%", "calc(100% - 310px)"],
                    display: "flex",
                    marginTop: ["0px", "0px"],
                    flexWrap: "wrap",
                    justifyContent: ["flex-start", "flex-start", "flex-end"],
                    flexDirection:['column', 'row', 'row'],
                    "> div": {
                      marginRight: ["0px", "25px","25px"],
                      marginBottom: ["5px", "15px","15px"],
                      display: "flex",
                      alignItems: "center",
                    },
                    ul: {
                      margin: "0px",
                      padding: "0px",
                      display: "flex",
                      marginBottom: "15px",
                      alignItems: ["left","center", "center"],
                      flexDirection:['column', 'row', 'row'],
                    },
                    li: {
                      marginRight: "25px",
                      listStyle: "none",
                      "&:last-child": {
                        marginRight: "0px",
                      },
                    },
                    a: {
                      color: "#F1F1F1",
                      textDecoration: "none",
                      ":hover": {
                        textDecoration: "underline",
                      },
                    },
                    "#ot-sdk-btn-disabled": {
                      color: "#F1F1F1 !important",
                      textDecoration: "none",
                      cursor: "pointer !important",
                      border: "0px !important",
                      padding: "0px !important",
                      fontSize: "inherit !important",
                      lineHeight: "inherit !important",
                      ":hover": {
                        textDecoration: "underline",
                        backgroundColor: "transparent !important",
                      },
                    },
                  }}
                >
                  <div>&copy;{new Date().getFullYear()} Everplans</div>
                  <ul>
                    <li>
                      <Link to="/terms-of-service">Terms of Service</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                      <div id="ot-sdk-btn-disabled" class="ot-sdk-show-settings-disable">
                        Cookie Settings
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                sx={{
                  marginTop: "10px",
                  textAlign: "center",
                  fontSize: "0.875rem",
                }}
              >
                Everplans is not a licensed healthcare provider, medical
                professional, law firm, or financial advisory firm, and the
                employees of Everplans are not acting as your healthcare
                providers, medical professionals, attorneys, or financial
                advisors.
              </div>
            </Container>
          </div>
        </footer>
      )}
    />
  );
};

export default Footer;
